module.exports = __webpack_public_path__ + "static/media/altscore_response_peru.74eed77e.pdf";